import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { Contents } from '../../../Common/rules.module';
import { GetDataService } from '../../../services/userService/get-data.service';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from '../../../services/auth-service.service';
import { showCustomeAlert } from '../../../services/Alert/alert.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
import { incrementVersion } from '../admindashboard/dashboard.component';
@Component({
  selector: 'app-abandon-rule',
  imports: [QuillModule,ReactiveFormsModule,CommonModule,FormsModule,RouterModule,LoaderComponent],
  templateUrl: './abandon-rule.component.html',
  styleUrl: './abandon-rule.component.scss'
})
export class AbandonRuleComponent implements OnInit {
  contentData: Contents | null = null;
  section: any;
  rule: any;
  isEditable:boolean = false;
  userDetails : any;
  form = new FormGroup({
    isEdited: new FormControl(false, [Validators.required]),
    title: new FormControl(
      "",
      [Validators.required]
    ),
    content: new FormControl(
      "",
      [Validators.required]
    ),
    version: new FormControl(
      "",[Validators.required],
    ),
    parentContentID: new FormControl(
      0
    ),
    contentTypeID: new FormControl(
      0
    ),
    abandonedNote: new FormControl(
      "",
      [Validators.required]
    ),
    displayOrder: new FormControl(
      0
    )
  });

  constructor(private fb: FormBuilder, private _activeRoute: ActivatedRoute,private _dataService : GetDataService,private router:Router,private _authService:AuthServiceService) { }
  
  ngOnInit(): void {
    this.section = this._activeRoute.snapshot.paramMap.get("div");
    this.userDetails = this._authService.getUserSession();
    this._dataService.getDataById(this.section).subscribe((d:any)=>{
      const section = d.find((r:any)=>r.id == this.section)
      this.contentData = section;
      if(this.contentData){
        this.form.patchValue({
          isEdited: this.contentData.isEdited,
          title:  this.contentData.title,
          content:  this.contentData?.content,
          version:  incrementVersion(this.contentData.version),
          parentContentID:  this.contentData.parentContentID,
          contentTypeID:  this.contentData.contentTypeID,
          abandonedNote:  this.contentData.abandonedNote,
          displayOrder:  this.contentData.displayOrder,
        });
      }
    })
  }

  editorConfig = {
    toolbar: [
      ['blockquote', 'code-block'],
      ['bold', 'italic', 'underline'],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean'],
      [{ 'direction': 'rtl' }],
    ]
  };

  isEditedEnabled(){
    this.isEditable = !this.isEditable;
  }

  onSubmit(): void {
    this.form.get('version')?.valueChanges.subscribe(value => {
      if (value == this.contentData?.version) {
        this.form.get('version')?.setErrors({ sameVersion: true });
      } else {
        this.form.get('version')?.setErrors(null);
      }
    });
    if (this.form.valid && this.form.value.version != this.contentData?.version) {
      
      const requestBody = {
        node : this.form.value,
        version : this.form.value.version,
      }
      this._dataService.addData(requestBody,this.userDetails.userName,this.section).subscribe(
        response => {
          if (response) {
            this.router.navigate(['admin'])
          }
        },
        error => {
          showCustomeAlert("error","Error occured while saving the section","Error..!")
          this.router.navigate(['admin'])

        }
      )
    } else {
      showCustomeAlert('warning',"Verison should be not same as previous one & all fields are required..","Alert")
      this.form.markAllAsTouched();
    }
  }

  back(){
    const id =  this._activeRoute.snapshot.paramMap.get("id")
    this.router.navigate([`/admin/section/${id}`],);
  }
}
